<template>
	<select class="select-view" @input="$emit('input', $event.target.value)">
		<option value="">Choose...</option>
		<option v-for="(opt, i) in options" v-bind:key="i" :value="opt.value" :selected="opt.value == value ? 'selected' : ''">{{ opt.label }}</option>
	</select>
</template>

<script>
	export default {
		name: 'select-view',
		props: {
			value: {
				
			},
			options: {
				type: Array,
				required: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.select-view {
		height: 30px;
		width: 194px;
	}
</style>